import { BehaviorSubject, combineLatest } from 'rxjs';
import { getThemaColor } from '../constants/AppConstants';
import { locationSubject } from '../history';
import { Location } from 'history';
import { Kapitel, kapitelsSubject } from './KapitelStore';
import { Thema, themasSubject } from './ThemaStore';

export const kapitelSubject = new BehaviorSubject<number>(1);
export const themaSubject = new BehaviorSubject<number | null>(1);
const initialThema = themaSubject.value ?? 1;
export const colorSubject = new BehaviorSubject<string>(getThemaColor(initialThema));
export const bgThemaSubject =new BehaviorSubject(`bg-thema${initialThema}`);
export const textThemaSubject =new BehaviorSubject(`text-thema${initialThema}`);
export const borderThemaSubject =new BehaviorSubject(`border-thema${initialThema}`);
export const audioPlayerIdsSubject = new BehaviorSubject<Set<string>>(new Set());
export const kapitelValueSubject = new BehaviorSubject<Kapitel | null>(null);
export const themaValueSubject = new BehaviorSubject<Thema | null>(null);
export const kapitelThemasSubject = new BehaviorSubject<Thema[]>([]);

combineLatest(kapitelSubject, kapitelsSubject)
    .subscribe(([kapitel, kapitels]) => kapitelValueSubject.next(kapitels.find(x => x.kapitel === kapitel) || null));
combineLatest(kapitelSubject, themasSubject)
    .subscribe(([kapitel, themas]) => kapitelThemasSubject.next(themas.filter(x => x.kapitel === kapitel)));
combineLatest(kapitelSubject, themaSubject, themasSubject)
    .subscribe(([kapitel, thema, themas]) => themaValueSubject.next(themas.find(x => x.kapitel === kapitel && x.thema === thema) || null));

themaSubject.subscribe((thema: number | null) => {
    const t = thema ?? 1;
    colorSubject.next(getThemaColor(t));
    bgThemaSubject.next(`bg-thema${t}`);
    textThemaSubject.next(`text-thema${t}`);
    borderThemaSubject.next(`border-thema${t}`);
});

export const setKapitel = (kapitel: number) => kapitelSubject.next(kapitel);
export const setThema = (thema: number | null) => themaSubject.next(thema);

locationSubject.subscribe((location: Location) => {
    const elements = location.pathname.split('/');

    // TODO: make this logic more generic
    if (elements.length !== 4) {
        setThema(1);
        return;
    }

    const potentialKapitel = parseInt(elements[2]);
    const potentialThema = parseInt(elements[3]);

    if (!isNaN(potentialKapitel) && potentialKapitel !== kapitelSubject.value) {
        setKapitel(potentialKapitel);
    }

    if (!isNaN(potentialThema) && potentialThema !== themaSubject.value) {
        setThema(potentialThema);
    }
});
